<template>
    <div style=" position: relative;height: 100%;width: 100%;background-color: #FFFFFF;">
        <div style="height: 100%;width: 100%" v-show="showDzm">
          <div style="border-top: 1px solid #ededed" ></div>
          <el-row style="height: calc(100% - 1px );width: 100%;position: absolute;">
              <el-col :span="6" class="div-left" style="position: relative;height: 100%;"  >
                  <div style="position: absolute;top: 20px;left: 20px;z-index: 1">
                    <el-radio-group v-model="queryType" size="small" @input="calDzm">
                      <el-radio-button label="TODAY">今日</el-radio-button>
                      <el-radio-button label="YESTERDAY">昨日</el-radio-button>
                      <el-radio-button label="THIS_MONTH">本月</el-radio-button>
                      <el-radio-button label="LAST_MONTH">上月</el-radio-button>
                      <el-radio-button label="THIS_YEAR">本年</el-radio-button>
                      <el-radio-button label="LAST_YEAR">去年</el-radio-button>
                    </el-radio-group>
                  </div>
                  <!--图列-->
                  <div v-show="show.tl" style="position: absolute;z-index: 11;bottom: 160px;left: 0;width: 33px;height: 120px;background-color: #1292e5;
                      border-radius:0 5px 5px 0;cursor: pointer;"  @click="show.tl = ! show.tl">
                      <div class="triangle" style="border-left: 6px solid #FFFFFF;position: absolute;transform: translate(-50%,0);left:50%;top:10px" ></div>
                      <span style="position: absolute;color: #fff;padding:25px 10px 10px 10px;font-size: 12px">等值面图例</span>
                  </div>
                  <div v-show="!show.tl">
                    <div v-if="!isLine"  style="position: absolute;z-index: 11;bottom: 4vw;left: 10px;width: 380px;background-color: #1292e5; border-radius:0 5px 5px 0;">
                      <div style="height: 33px;position: relative;cursor: pointer"  @click="show.tl = !show.tl">
                        <div class="triangle" style="border-right: 6px solid #FFFFFF;position: absolute;transform: translate(-50%,-50%);left:10px;top:50%" ></div>
                        <span style="position: absolute;color: #fff;left:50%;transform: translate(-50%,-50%);top:50%;font-size: 12px">等值面图例</span>
                      </div>
                      <el-row style="background-color: #fff;margin:1px">
                        <el-col :span="5" style="border-right: 1px solid #e4e4e4;">
                          <div  style="background-color: #f7f7f7;display: flex;align-content: center">
                            <span style="color: #323232;height: 30px;font-size: 12px;line-height: 30px;margin: 0 auto">图例</span>
                          </div>
                          <div v-for="item in legend1" :key="item.color" :style="{backgroundColor: item.color}" class="tl_showColor"></div>

                        </el-col>
                        <el-col :span="7">
                          <div  style="background-color: #f7f7f7;display: flex;align-content: center">
                            <span style="color: #323232;height: 30px;font-size: 12px;line-height: 30px;margin: 0 auto">等级（mm）</span>
                          </div>
                          <div  class="tl_jb" v-for="item in legend1" :key="item.level">
                            <span class="tl_jb_content" >{{item.level}}</span>
                          </div>

                        </el-col>
                        <el-col :span="5">
                          <div  style="background-color: #f7f7f7;display: flex;align-content: center">
                            <span style="color: #323232;height: 30px;font-size: 12px;line-height: 30px;margin: 0 auto"> 图例</span>
                          </div>
                          <div  v-for="item in legend2" :key="item.color" :style="{backgroundColor: item.color}" class="tl_showColor"></div>
                        </el-col>
                        <el-col :span="7">
                          <div  style="background-color: #f7f7f7;display: flex;align-content: center">
                            <span style="color: #323232;height: 30px;font-size: 12px;line-height: 30px;margin: 0 auto">等级（mm）</span>
                          </div>
                          <div  class="tl_jb" v-for="item in legend2" :key="item.level">
                            <span class="tl_jb_content" >{{item.level}}</span>
                          </div>

                        </el-col>
                      </el-row>
                    </div>
                  </div>
              </el-col>
          </el-row>
        <div v-loading="loading"
             element-loading-text="正在运算中"
             element-loading-spinner="el-icon-loading"
             element-loading-background="rgba(0, 0, 0, 0.8)"
             ref="iirms_dzm"  style="position: absolute;width: 100%;height: calc(100% - 1px)">
        </div>
        <span style="font-size: 15px;font-family: 'Microsoft YaHei',serif;position: absolute;top: 10px;right: 10px;color: #1c8cb4">
          铜场水库{{dateRange}}雨量{{isLine ? '等值线' : '等值面'}}情况图
        </span>
        <span style="font-size: 1.4rem;font-family: 'Microsoft YaHei',serif;position: absolute;bottom: 10px;right: 10px;">雨量{{isLine ? '等值线' : '等值面'}}{{dateRange}}</span>
      </div>
    </div>
</template>

<script>
import Projection from 'ol/proj/Projection';
import * as extent from 'ol/extent';
import View from 'ol/View';
import * as control from 'ol/control';
import Map from 'ol/Map';
import Image from 'ol/layer/Image';
import ImageWMS from 'ol/source/ImageWMS';
import GeoJSON from 'ol/format/GeoJSON';
import SVector from 'ol/source/Vector';
import LVector from 'ol/layer/Vector';
import Text from 'ol/style/Text';
import Fill from 'ol/style/Fill';
import Style from 'ol/style/Style';
import Stroke from 'ol/style/Stroke';
import ScaleLine from 'ol/control/ScaleLine';
import VectorSource from "ol/source/Vector";
import VectorLayer from "ol/layer/Vector";

export default {
  name: "screen_dzm",
  data () {
      return {
        queryType: 'THIS_MONTH',
        show:{
            tl:false,
        },
        bound : [82.7390879287941,41.830490529411406,83.70206019702039,42.579445884632435],
        map: null,
        tiled: null,
        loading: false,
        dzmVector: null,
        dateRange: null,
        monthVal: 1,
        isLine: true,
        legend1: [],
        legend2: [],
        showDzm: true
      }
  },
  mounted() {
    this.initMap();
    this.calDzm();
  },
  methods:{
    onInit(){
      this.showDzm = true;
    },
    onClear(){
      this.showDzm = false;
    },
    changeImageType(type,needQuery){
      console.log(type)
      if('dzx' === type){
        this.isLine = true;
      }else {
        this.isLine = false;
      }
      if(needQuery) {
        this.clearMap();
        this.calDzm();
      }
    },
    clearMap(){
      /*this.map.getLayers().forEach((layer) =>{
        // 将图层从地图中移除
        this.map.removeLayer(layer);
      });*/
      if(this.tiled){
        this.map.removeLayer(this.tiled);
      }
      if(this.dzmVector){
        this.map.removeLayer(this.dzmVector);
      }
    },
    initMap() {
      const mapTarget = this.$refs.iirms_dzm;
      const projection = new Projection({
        code: 'EPSG:4326',
        units: 'degree',
        extent:this.bound
      });
      //添加比例尺
      const scaleLineControl = new ScaleLine({units:'metric', bar: true,minWidth: 165});

      this.map = new Map({
        controls: control.defaults({
          attribution: false
        }).extend([
          scaleLineControl        // 将比例尺控件添加到地图中
        ]),
        target: mapTarget,
        layers: [],
        view: new View({
          projection:projection,
          center: extent.getCenter(this.bound), //
          zoom: 2,
          minZoom:1,
          maxZoom:16,
        })
      });
      this.map.render();
    },
    calDzm(){
      const skdm = localStorage.getItem("skCd") ? localStorage.getItem("skCd") : null;
      if(skdm !== '65292330001'){
        if(this.showDzm) {
          this.showDzm = false;
        }
        return;
      }
      this.loading = true;
      const params = {queryDateType:this.queryType,isLine: this.isLine};
      this.request.get("/rm-drain/v1/dzm",{params: params}).then((res) => {
        if(res.ok){
          const data = res.data;
          if(data) {
            const zoned = data.zoned;
            this.monthVal = data.month;
            this.dateRange = data.dateRange;
            /*if(!this.title){
              this.title = data.month + this.titleObject[queryType];
            }*/
            if(data.result) {
              const faceFeatures = (new GeoJSON()).readFeatures(data.result);
              if (this.isLine) {
                const vectorSource = new VectorSource({
                  features: faceFeatures
                });
                this.tiled = new Image({
                  source: new ImageWMS({
                    params: {'LAYERS': 'zxsk:tcsk', 'VERSION': '1.1.0', 'SRS': 'EPSG:4326'},
                    serverType: 'geoserver',
                    url: '//gis.hyicloud.com/zxsk/wms/',
                  }),
                });
                this.map.addLayer(this.tiled);
                // 创建线图层
                this.dzmVector = new VectorLayer({
                  source: vectorSource,
                  style: function (feature) {
                    const lvalue = feature.values_.value;
                    return new Style({
                      stroke: new Stroke({
                        color: "#DF614E",
                        width: 2
                      }),
                      text: new Text({
                        text: lvalue.toFixed(1),
                        // textAlign: 'end',
                        // textBaseline: 'top',
                        // font: '1.2rem Microsoft YaHei'
                      })
                    });
                  }
                });
                this.map.addLayer(this.dzmVector);
                this.map.render();
              } else {
                this.legend1 = data.legend1;
                this.legend2 = data.legend2;
                const zonedArr = [];
                if(zoned) {
                  zoned.forEach(n => {
                    const one = {pd: [], z: n.Z};
                    const pd = n.PD.split(',');
                    if (pd[0]) {
                      one.pd.push(parseFloat(pd[0]));
                    } else {
                      one.pd.push(undefined);
                    }
                    if (pd[1]) {
                      one.pd.push(parseFloat(pd[1]));
                    } else {
                      one.pd.push(undefined);
                    }
                    zonedArr.push(one);
                  })
                }
                const dzmVectorSource = new SVector();
                dzmVectorSource.addFeatures(faceFeatures);
                this.dzmVector = new LVector({
                  source: dzmVectorSource,
                  style: function (feature) {
                    const lvalue = feature.get("lvalue");
                    if(isNaN(lvalue)){
                      return null;
                    }
                    let color = "#FFFFFF";
                    zonedArr.forEach(n => {
                      if (n.pd[0]) {
                        if (lvalue >= n.pd[0]) {
                          if (n.pd[1]) {
                            if (lvalue < n.pd[1]) {
                              color = n.z;
                            }
                          } else {
                            color = n.z;
                          }
                        }
                      } else {
                        if (n.pd[1]) {
                          if (lvalue < n.pd[1]) {
                            color = n.z;
                          }
                        }
                      }
                    });
                    return new Style({
                      stroke: new Stroke({
                        color: '#ffffff',
                        width: 1
                      }),
                      fill: new Fill({
                        color: color,
                      }),
                      text: new Text({text: lvalue.toFixed(1)})
                    });
                  },
                  opacity: 1
                });
                this.map.addLayer(this.dzmVector);
              }
            }else {
              this.tiled = new Image({
                source: new ImageWMS({
                  params: {'LAYERS': 'zxsk:tcsk', 'VERSION': '1.1.0', 'SRS': 'EPSG:4326'},
                  serverType: 'geoserver',
                  url: '//gis.hyicloud.com/zxsk/wms/',
                })
              });
              this.map.addLayer(this.tiled);
            }
          }else{
            this.tiled = new Image({
              source: new ImageWMS({
                params: {'LAYERS': 'zxsk:tcsk', 'VERSION': '1.1.0', 'SRS': 'EPSG:4326'},
                serverType: 'geoserver',
                url: '//gis.hyicloud.com/zxsk/wms/',
              })
            });
            this.map.addLayer(this.tiled);
          }
          this.map.render();
          this.map.updateSize();
          this.loading = false;
        }else{
          this.loading = false;
          this.$message.error(res.error.message);
        }
      });
    }
  }
}
</script>

<style scoped>
.spjz{
    position: absolute;
    transform: translate(-50%, -50%);
}
.tl_showColor{
  height: 20px;margin:10px 12px;display: flex;align-content: center
}
.tl_jb{
  height: 20px;margin:10px 12px;display: flex;align-content: center
}
.tl_jb_content{
  color: #323232;font-size: 12px;margin: 0 auto
}
.triangle {
    width: 0;
    height: 0;
    border-top: 6px solid transparent;
    border-bottom: 6px solid transparent;
}
</style>
